<template>
  <div class="add-contents" :class="{ 'full-screen': fullScreen }">
    <div class="content">
      <component
        v-bind:is="mediaElem"
        :class="customClass"
        :media="mediaFile"
        @ended="nextStep"
        @error="mediaError"
        @success="removeErrors"
      />
    </div>
  </div>
</template>

<script>
import AdVideo from '@/components/playlist/ad-media-playlist/AdVideo.vue'
import AdImage from '@/components/playlist/ad-media-playlist/AdImage.vue'

export default {
  name: 'AdPlayList',
  props: {
    playListItems: {
      type: Array,
      required: true
    },
    fullScreen: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      step: 0,
      brokenMediaItems: 0,
      mediaElem: null,
      mediaFile: null,
      errorTimeUpdate: null,
      timeoutId: null
    }
  },
  watch: {
    playListItems () {
      if (this.mediaIsError) {
        this.removeErrors()
        this.nextStep()
      }
    }
  },
  computed: {
    customClass () {
      return {
        vertical: this.mediaFile && this.mediaFile.isVerticalOrientation(),
        horizontal: this.mediaFile && this.mediaFile.isHorizontalOrientation()
      }
    },
    mediaIsError () {
      return this.brokenMediaItems >= this.playListItems.length
    }
  },
  methods: {
    isVideo () {
      return this.mediaFile?.getFile()?.isVideoType()
    },
    isPicture () {
      return this.mediaFile?.getFile()?.isPictureType()
    },
    nextStep () {
      this.mediaFile = null
      this.mediaElem = null

      if (this.timeoutId) {
        this.timeoutId = null
      }

      this.$nextTick(() => {
        if (this.step + 1 >= this.playListItems.length) {
          this.step = 0
        } else {
          this.step++
        }

        this.timeoutId = setTimeout(() => this.initAction(), 50)
      })
    },
    initAction () {
      this.mediaFile = this.playListItems[this.step]
      this.mediaElem = this.isVideo() ? AdVideo : AdImage
    },
    mediaError () {
      this.brokenMediaItems++
      this.checkErrors()
    },
    checkErrors () {
      if (this.mediaIsError) {
        console.log('All media in the playlist in error')
        this.mediaElem = null
      } else {
        this.nextStep()
      }
    },
    removeErrors () {
      this.brokenMediaItems = 0
    }
  },
  beforeMount () {
    this.initAction()
  },
  beforeDestroy () {
    clearTimeout(this.timeoutId)
  }
}
</script>
